import { createReducer, on } from '@ngrx/store';
import { initialState } from './public-categories.state';
import * as PublicCategoriesActions from './public-categories.actions';

export const publicCategoriesReducer = createReducer(
  initialState,
  on(PublicCategoriesActions.loadPublicCategories, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(PublicCategoriesActions.loadPublicCategoriesSuccess, (state, { response }) => ({
    ...state,
    categories: response.content,
    isLoading: false
  })),
  on(PublicCategoriesActions.loadPublicCategoriesFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false
  }))
);
